import React from "react";

export default function CharityImg({ image }) {
  return (
    <div className='rui-right-image'>
      <img src={image} alt='charity logo' />
    </div>
  );
}
